import {config} from "../environment";
import {useAsync} from "../utils/utils";

export enum ResoknadMedlemskap {
  AKTIV = "AKTIV",
  TRUKKET_SEG = "TRUKKET_SEG"
}

type ResoknadStatusEntry = {
  fnr: string
  medlemskap: ResoknadMedlemskap
}

type ResoknadStatusResponse = {
  resokere: Array<ResoknadStatusEntry>
}

export type ResoknadStatus = keyof typeof ResoknadMedlemskap | 'INGEN'

async function getResoknadStatus(): Promise<ResoknadStatus> {
  return fetch(`${config.apiUrl}/api/resoknadstatus`)
  .then(res => res.json() as Promise<ResoknadStatusResponse>)
  .then(json => json.resokere[0]?.medlemskap ?? 'INGEN');
}

export const useResoknadStatus = useAsync(getResoknadStatus)
